import { render } from "./BookmarkModal.vue?vue&type=template&id=d1b65d14&scoped=true"
import script from "./BookmarkModal.vue?vue&type=script&lang=js"
export * from "./BookmarkModal.vue?vue&type=script&lang=js"

import "./BookmarkModal.vue?vue&type=style&index=0&id=d1b65d14&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b65d14"]])

export default __exports__